<template>
  <profile-edit-section-card
    v-if="localState"
    title="Bio"
    breadcrumb-label="Profile"
    :saving="isSaving"
    :has-unsaved-changes="hasUnsavedChanges"
    :has-invalid-input="hasInvalidInput"
    @breadcrumb-click="cancelEdit"
    @save="handleSave"
    @cancel="cancelEdit"
  >
    <text-area
      id="profile-bio"
      v-model="localState.bio"
      class="mb-24"
      label-name="Your experience"
      :character-counter="true"
      :min-characters="150"
      :max-characters="2500"
      :rows="6"
    />
  </profile-edit-section-card>
</template>

<script lang="ts">
import TextArea from '@/components/textarea/TextArea.vue';
import ProfileEditSectionCard from '../../components/ProfileEditSectionCard.vue';
import profileEditMixin from '../../mixins/profileEditMixin';
import { distanceOptions } from '../../__types__/CareTypeFormOptions';
import type { HousekeepingProfileFormState } from '../../__types__/HousekeepingProfileTypes';

export default {
  name: 'HousekeepingBioForm',
  components: {
    ProfileEditSectionCard,
    TextArea,
  },
  mixins: [profileEditMixin],
  data(): any {
    return {
      localState: null,
      originalState: null,
    };
  },
  computed: {
    distanceOptions: () => distanceOptions(),
    hasUnsavedChanges(): boolean {
      if (!this.localState || !this.originalState) return false;
      return JSON.stringify(this.localState) !== JSON.stringify(this.originalState);
    },
    hasInvalidInput(): boolean {
      if (!this.localState) return false;
      const bioLength = this.localState.bio.length;
      return bioLength < 150 || bioLength > 2500;
    },
  },
  watch: {
    $route() {
      this.initializeFormState();
    },
    formState: {
      handler(newState) {
        if (newState) {
          this.initializeFormState();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeFormState();
  },
  methods: {
    initializeFormState() {
      const state = this.formState as HousekeepingProfileFormState | null;
      if (!state) return;

      this.localState = {
        bio: state.bio || '',
      };
      this.originalState = JSON.parse(JSON.stringify(this.localState));
    },
    async handleSave() {
      if (!this.localState) return;

      if (this.hasUnsavedChanges) {
        await this.saveSection({
          bio: this.localState.bio,
        });
      }
    },
  },
};
</script>
